<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="2"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
          :detailName="detail.title"
        >
          <div slot="main_content">
            <div class="content_top" v-if="Object.keys(detail).length">
              <div class="article_con">
                <div class="content_item_u">
                  <div class="content_item_img">
                    <img v-lazy="detail.coverImg" />
                  </div>
                </div>
                <div class="content_item_d">
                  <p class="title">{{ detail.title }}</p>
                  <div class="item_d">
                    <div class="item_d_l">
                      <img src="../../assets/img/site_icon.png" />{{
                        $t('site')
                      }}
                    </div>
                    <div class="item_d_r">{{ detail.site }}</div>
                  </div>
                  <div class="item_d">
                    <div class="item_d_l">
                      <img src="../../assets/img/time_icon.png" />{{
                        $t('time')
                      }}
                    </div>
                    <div class="item_d_r">
                      {{ detail.performanceTime }}
                    </div>
                  </div>
                </div>
                <div class="detail_con" v-html="detail.content"></div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="isMobile"
        >
          <div slot="main_content">
            <div class="app_content_top" v-if="Object.keys(detail).length">
              <div class="article_con">
                <div class="content_item_u article_con_in">
                  <img v-lazy="detail.coverImg" />
                </div>
                <div class="content_item_d">
                  <p class="title">{{ detail.title }}</p>
                  <div class="item_d">
                    <div class="item_d_l">
                      <img src="../../assets/img/site_icon.png" />{{
                        $t('site')
                      }}
                    </div>
                    <div class="item_d_r">{{ detail.site }}</div>
                  </div>
                  <div class="item_d">
                    <div class="item_d_l">
                      <img src="../../assets/img/time_icon.png" />{{
                        $t('time')
                      }}
                    </div>
                    <div class="item_d_r">
                      {{ detail.performanceTime }}
                    </div>
                  </div>
                </div>
                <div class="app_detail_con" v-html="detail.content"></div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div></div
        ></AppcontentList>
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <AppFooter v-else />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import AppFooter from '@/components/AppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { themeTab } from '@/const';
import { getObj } from '@/assets/api';
export default {
  name: 'DramaActivityDetail',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    AppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      tabList: themeTab,
      cloumnId: '1947546062976917505', //栏目id
      detail: {
        id: 1,
        img: require('@/assets/img/homeimgs/activity_01.png'),
        title: '《仲夏夜之梦》',
        unit: '窦辉工作室',
        adapt: '改编自威廉·莎士比亚剧作',
        director: '导演  窦辉',
        startTime: '10月17日19:30',
        endTime: '10月18日19:30',
        site: '北栅粮仓一号馆1A',
        duration: '60分钟 ( 无中场休息 )',
        content:
          '<p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;;">这几天空气里终于有了些春天的味道啦！气温回暖，阳光甚好，周末约上了朋友一起自驾去照金春游，是的，我又去照金啦，去不厌的地方，嘿嘿~</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;;">从上海自驾到照金大约三个半小时，去了超级梦幻的瑶琳仙境和“小桂林”天目溪漂流，真的很适合现在的天气去游玩，推荐给你们哦！</p><p cms-style="font-L strong-Bold" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;;">瑶琳仙境</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;;">这是我去过最漂亮的天然溶洞，有一种闯入梦幻地心世界的感觉！里面常年温度在16度，不冷也不热，刚刚好的感觉。</p><div><br></div>',
      },
      id: '',
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.cloumnId = this.$route.query.cloumnId || null;
    this.getDetail();
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      // this.getList();
    },
    handleClick(tab, event) {
      this.$nextTick(() => {
        const element = document.getElementById(`section${tab.index}`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start', // 对齐到顶部
          });
        }
      });
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    getDetail() {
      getObj(this.id).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/styles/vhtml.scss';
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      width: 100%;
      box-sizing: border-box;
      .content_item_u {
        width: 46.7%;
        height: 41.5rem;
        img {
          width: 100%;
          height: auto;
          object-fit: cover;
        }
      }
      .content_item_d {
        width: 46.7%;
        padding: 1.3333rem 1.6667rem;
        background-color: #f0f1f2;
        box-sizing: border-box;
        .title {
          font-size: 1.75rem;
          color: #333;
          display: -webkit-box; /* 旧版 Flex 布局 */
          -webkit-line-clamp: 2; /* 限制行数 */
          -webkit-box-orient: vertical; /* 垂直排列 */
          overflow: hidden; /* 隐藏溢出 */
          text-overflow: ellipsis;
          font-family: SourceHanSansCN-Medium;
        }
        .item_d {
          display: flex;
          justify-content: flex-start;
          font-size: 1.125rem;
          margin: 0.3125rem 0;
          .item_d_l {
            display: flex;
            align-items: center;
            font-family: SourceHanSansCN-Medium;
            img {
              width: 1.25rem;
              height: 1.25rem;
            }
          }
          .item_d_r {
            display: inline-block;
            color: #6b6d7a;
            margin-left: 0.3125rem;
          }
        }
      }
    }
  }
  .app_content_con {
    background: #fff;
  }
  .app_content_top {
    background: #fff;
    margin: 2rem 0;
    .article_con {
      background: #fff;
      width: 100%;
      box-sizing: border-box;

      .content_item_u {
        background: #f0f1f2;
        .content_item_img {
          width: 100%;
          height: 45.4167rem;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .content_item_d {
        padding: 1.3333rem 1.6667rem;
        background-color: #f0f1f2;
        .title {
          font-size: 1.1667rem;
          color: #333;
          display: -webkit-box; /* 旧版 Flex 布局 */
          -webkit-line-clamp: 2; /* 限制行数 */
          -webkit-box-orient: vertical; /* 垂直排列 */
          overflow: hidden; /* 隐藏溢出 */
          text-overflow: ellipsis;
          font-family: SourceHanSansCN-Medium;
        }
        .item_d {
          display: flex;
          justify-content: flex-start;
          font-size: 0.8333rem;
          margin: 0.3125rem 0;
          .item_d_l {
            display: flex;
            align-items: center;
            font-family: SourceHanSansCN-Medium;
            img {
              width: 1.25rem;
              height: 1.25rem;
            }
          }
          .item_d_r {
            display: inline-block;
            color: #6b6d7a;
            margin-left: 0.3125rem;
          }
        }
      }

      .article_con_d {
        margin-top: 1.6667rem;
        .tab_con {
          .tab_item {
            margin: 2.6667rem 0 1.6667rem;
            .title {
              display: flex;
              justify-content: space-between;
              align-items: center;
              h3 {
                color: #424451;
                font-size: 1.3333rem;
              }
              .english {
                color: #c2c4ce;
                font-size: 0.8333rem;
                margin: 0 1.5rem;
                text-transform: uppercase; /* 强制转为大写 */
              }
              .line {
                flex: 1;
                height: 0.0625rem;
                background: #dadbdf;
              }
            }
          }
        }
      }
    }
  }
}
.content_top {
  .swiper-button-next,
  .swiper-button-prev {
    width: 48px;
    height: 96px;
    /* background-color: rgba(255, 255, 255, 0.2); */
    position: absolute;
    top: 50%;
    transform: translateY(-48px);
  }
}
.app_content_top {
  .swiper-button-next,
  .swiper-button-prev {
    width: 1.5rem;
    height: 3rem;
    /* background-color: rgba(255, 255, 255, 0.2); */
    position: absolute;
    top: 50%;
  }
}

.swiper-button-next {
  right: 0%;
  background-image: url('../../assets/img/homeimgs/y@2x.png') !important;
  background-size: 100% 100%;
  cursor: pointer;
}

.swiper-button-prev {
  left: 0%;
  background-size: 100% 100%;
  background-image: url('../../assets/img/homeimgs/z@2x.png') !important;
  cursor: pointer;
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
  .detail_con {
    margin-top: 2rem;
    color: #666 !important;
    font-size: 1.125rem !important;
    font-family: SourceHanSansCN-Normal !important;
    line-height: 2.5rem !important;
    p,
    span,
    strong {
      color: #666 !important;
      font-size: 1.125rem !important;
      font-family: SourceHanSansCN-Normal !important;
      line-height: 2.5rem !important;
    }
  }
  .content_top {
    .el-tabs__item.is-active {
      color: #2a2a2a;
      font-family: SourceHanSansCN-Medium;
      font-size: 1.5rem;
    }
    .el-tabs__item {
      color: #6b6d7a;
      font-size: 1.5rem;
      height: 3.75rem;
    }
    .el-tabs__nav-wrap::after {
      height: 0.5rem;
      background-color: #eaeaea;
    }
    .el-tabs__active-bar {
      height: 0.5rem;
      background-color: #2a2a2a;
      border-radius: 100px;
    }
  }
  .app_content_top {
    .el-tabs__item.is-active {
      color: #2a2a2a;
      font-family: SourceHanSansCN-Medium;
      font-size: 1.1667rem;
    }
    .el-tabs__item {
      color: #6b6d7a;
      font-size: 1.1667rem;
      height: 3.75rem;
    }
    .el-tabs__nav-wrap::after {
      height: 0.5rem;
      background-color: #eaeaea;
    }
    .el-tabs__active-bar {
      height: 0.5rem;
      background-color: #2a2a2a;
      border-radius: 100px;
    }
  }
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
